var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 32,
    viewBox: "0 0 67 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10745_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3152 15H54C44.7236 4.92395 34.0667 4.6482 29.9083 4.32833C25.7499 4.00846 13.1149 3.84852 0 8.64663C5.59782 4.96808 13.4348 0.329895 29.7484 0.0100122C38.2245 -0.156191 45.6763 1.76183 51.8197 4.6482C61.597 9.24184 66.3152 15 66.3152 15Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4549 18H53.5C45.3432 25.3571 40.944 27.1993 32.4673 28.159C25.0683 28.9966 16.3136 26.5596 9.75621 25.4401C16.7934 29.2785 23.935 32.095 33.5869 31.9975C47.7032 31.8549 57.8183 26.7965 66.4549 18Z",
    fill: "#191C21"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2298,
    cy: 15.8439,
    rx: 8.9565,
    ry: 10.0761,
    fill: "#007A3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10745_68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H54.2C58.6804 0 60.9206 0 62.6319 0.871948C64.1372 1.63893 65.3611 2.86278 66.1281 4.36808C67 6.07937 67 8.31958 67 12.8V19.2C67 23.6804 67 25.9206 66.1281 27.6319C65.3611 29.1372 64.1372 30.3611 62.6319 31.1281C60.9206 32 58.6804 32 54.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.fae5d90def1f0a4d71461a8e6f164040.svg";
export { ForwardRef as ReactComponent };